import {
  FieldSection,
  FieldSectionTitle,
  FieldsRow,
  FormContainer,
  FormNumberField,
  FormRadioLine,
  FormRoleConfContext,
  FormSearchField,
  FormTextField,
  useRoleConf,
} from "@pharmupp/p3-front-commons"
import { formRoleConf } from "./Location.formRoleConf"
import { LocationEnum, type LocationFormValues } from "./Location.schema"
import { locationsReferential } from "./referential/location.referential"

export const Location = () => {
  const conf = useRoleConf(formRoleConf)

  return (
    <FormRoleConfContext.Provider value={conf}>
      <FormContainer>
        <FieldSectionTitle title="Coordonnées" />

        <FieldSection title="Adresse" subtitle="Localisation de l'officine">
          <FormTextField<LocationFormValues>
            label="Numéro et rue"
            name={`${LocationEnum.ADDRESS}.${LocationEnum.LINE_1}`}
          />
          <FormTextField<LocationFormValues>
            label="Complément d'adresse"
            name={`${LocationEnum.ADDRESS}.${LocationEnum.LINE_2}`}
          />
          <FieldsRow>
            <FormNumberField<LocationFormValues>
              label="Code postal"
              name={`${LocationEnum.ADDRESS}.${LocationEnum.POSTAL_CODE}`}
              format="#####"
              fullWidth
            />
            <FormTextField<LocationFormValues>
              label="Ville"
              name={`${LocationEnum.ADDRESS}.${LocationEnum.CITY}`}
              fullWidth
            />
          </FieldsRow>
        </FieldSection>

        <FieldSection title="Implantation" subtitle="Implantation de l’officine">
          <FormSearchField<string, LocationFormValues>
            label="Implantation"
            name={LocationEnum.LOCATION}
            options={locationsReferential}
            valueFormat="optionValue"
            multiple
          />
          <FormRadioLine<LocationFormValues>
            label="Parking devant l'officine"
            name={LocationEnum.FRONT_PARKING}
            defaultValue={false}
            radios={[
              { label: "Oui", value: true },
              { label: "Non", value: false },
            ]}
          />
        </FieldSection>
      </FormContainer>
    </FormRoleConfContext.Provider>
  )
}
